import React from 'react';
import './ImportChildQuestionsDialog.css';

interface ImportChildQuestionsDialogProps {
  childCount: number;
  onImportWithChildren: () => void;
  onImportWithoutChildren: () => void;
  onCancel: () => void;
}

const ImportChildQuestionsDialog: React.FC<ImportChildQuestionsDialogProps> = ({
  childCount,
  onImportWithChildren,
  onImportWithoutChildren,
  onCancel,
}) => {
  return (
    <div className='import-child-modal-overlay'>
      <div className='import-child-modal'>
        <h3>השאלה הנבחרת מכילה {childCount} שאלות ילד</h3>
        <p>האם לייבא אותן יחד עם השאלה?</p>
        <hr className='import-child-modal-separator' />
        <div className='import-child-modal-buttons'>
          <button onClick={onCancel}>ביטול</button>
          <button className='secondary' onClick={onImportWithoutChildren}>
            ייבא ללא שאלות ילד
          </button>
          <button className='primary' onClick={onImportWithChildren}>
            ייבא עם שאלות ילד
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportChildQuestionsDialog;
